import OverflowTooltip from '@/components/OverflowTooltip';
import { formatCentToYuan, formatCommonDate, formatString } from '@zcy/util-store';
import { Badge, Form, Tooltip } from 'doraemon';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import TextWithTooltip from 'src/components/TextWithTooltip';
import { v4 as uuidv4 } from 'uuid';

const FormItem = Form.Item;
export const STATUS_LIST = [
  {
    label: '未完成',
    value: '2',
  },
  {
    label: '已完成',
    value: '1',
  },
];

export const CLAIM_UNFINISH_STATUS = [
  { value: 0, name: '未提交' },
  { value: 1, name: '处理中' },
  { value: 2, name: '已驳回' },
  { value: 3, name: '结算中' },
];

export const APPLY_COLUMNS = changeLabel => [
  {
    title: '单据类型',
    dataIndex: 'sceneTypeDesc',
    width: 150,
    key: 'sceneTypeDesc',
    render: (text, record) => {
      const temp = record.sceneType === 'TRAVEL' ? text + '-' + record.businessTypeDesc : text;
      return <TextWithTooltip text={changeLabel ? changeLabel({ label: temp }) : temp} />;
    },
  },
  {
    title: '单据编号',
    dataIndex: 'businessCode',
    width: 120,
    key: 'businessCode',
  },
  {
    title: '申请事由',
    dataIndex: 'reason',
    width: 180,
    key: 'reason',
    render: text => <TextWithTooltip text={formatString(text)} />,
  },
  {
    title: '申请人',
    dataIndex: 'submitterName',
    width: 80,
    key: 'submitterName',
    render: (text, record) => {
      return text ? (
        <div>
          {text}
          {record.userTagList?.some(v => v.key === 2) && (
            <span className="personal-type">同行人</span>
          )}
          {record.userTagList?.some(v => v.key === 3) && (
            <span className="personal-type">被转交</span>
          )}
          {record.formSource === 2 && <span className="personal-type">OA</span>}
        </div>
      ) : (
        '-'
      );
    },
  },
  {
    title: '部门',
    dataIndex: 'deptName',
    width: 180,
    key: 'deptName',
    render: text => <TextWithTooltip text={formatString(text)} />,
  },
  {
    title: '申请时间',
    dataIndex: 'timeDesc',
    width: 150,
    key: 'timeDesc',
    render: text => <TextWithTooltip text={formatString(text)} />,
  },
];

export const CLAIM_FORM_TYPE = [
  {
    value: 1,
    name: '差旅报销',
  },
  {
    value: 2,
    name: '会议报销',
  },
  {
    value: 3,
    name: '培训报销',
  },
  {
    value: 4,
    name: '办公用品报销',
  },
  {
    value: 6,
    name: '公务接待报销',
  },
  {
    value: 7,
    name: '一般事项报销',
  },
  {
    value: 9,
    name: '通用采购报销',
  },
  {
    value: 10,
    name: '政府购买服务报销',
  },
  {
    value: 11,
    name: '办公设备家具购置报销',
  },
  // {
  //   value: 12,
  //   name: '多收款人会议报销',
  // },
  // {
  //   value: 13,
  //   name: '多收款人培训报销',
  // },
  {
    value: 14,
    name: '公共事业缴费报销',
  },
];

export const EXPENSE_FORM_TYPE_MAP = {
  trip: 1, //  差旅
  meeting: 2, // 会议
  training: 3, // 培训
  purchase: 4, // 办公用品采购
  reception: 6, // 公务接待
  general: 7, // 一般事项
  common: 9, // 通用采购
  services: 10, // 政府购买服务
  furniture: 11, // 办公设备家具购置
  multipleMeeting: 12, // 会议多收款
  multipleTraining: 13, // 培训多收款
  publicPayment: 14, // 公共事业缴费
  batchDistribute: 15, // 批量发放
  salary: 11016, // 工资，报销场景没有此字段，只作为前端支付配置取值
  overtime: 11022, // 夜餐费发放单，报销场景没有此字段，只作为前端支付配置取值
  batchDistribute_cash: 'batchDistribute_cash', // 企业兑付非报销场景，只作为前端支付配置取值
  governmentInvestmentPayment: 'governmentInvestmentPayment', // 政府投资支付单
  automaticDeduction: 'automaticDeduction', // 单位还款单
  // unitRepayment: 'unitRepayment', // 代扣还款（单位）申请
  carUseService: 21, // 公车服务报销单
};
/**
 * 报销单状态
 */
export const CLAIM_STATUS_MAP = ({ expenseFormStatus, processStatus }) => {
  if (expenseFormStatus === 0) {
    return {
      component: <Badge status="default" text="未提交" />,
      img: 'https://sitecdn.zcycdn.com/f2e-assets/d15ffe89-267a-4de0-80b7-fb611cc6d60b.svg',
      text: '未提交',
    };
  }
  if (expenseFormStatus === 1) {
    return {
      component: (
        <Badge status="processing" text={processStatus === 'IN_APPROVE' ? '待审批' : '待审核'} />
      ),
      img:
        processStatus === 'IN_APPROVE'
          ? 'https://sitecdn.zcycdn.com/f2e-assets/d3cc254c-d240-4f08-8b4a-d343e0c17bda.svg'
          : 'https://sitecdn.zcycdn.com/f2e-assets/17e09503-2fc0-4616-ad0b-c3aa1c0d9297.svg',
      text: processStatus === 'IN_APPROVE' ? '待审批' : '待审核',
    };
  }
  if (expenseFormStatus === 2) {
    return {
      component: <Badge status="default" text="已驳回" />,
      img: 'https://sitecdn.zcycdn.com/f2e-assets/43d368ba-fd46-4c5b-8b7e-c831486c7ddd.svg',
      text: '已驳回',
    };
  }
  if (expenseFormStatus === 3) {
    return {
      component: <Badge status="processing" text="结算中" />,
      img: 'https://sitecdn.zcycdn.com/f2e-assets/5a535ff4-5894-4f92-a738-2b3291b1859c.svg',
      text: '结算中',
    };
  }
  if (expenseFormStatus === 4) {
    return {
      component: <Badge status="success" text="已完成" />,
      img: 'https://sitecdn.zcycdn.com/f2e-assets/a5248bb3-87ae-407b-a3f4-8077dce72c70.svg',
      text: '已完成',
    };
  }
  if (expenseFormStatus === 5) {
    return {
      component: <Badge status="error" text="支付失败" />,
      img: 'https://sitecdn.zcycdn.com/f2e-assets/19832834-510e-4f17-8aa1-93da5c778030.svg',
      text: '支付失败',
    };
  }
  if (expenseFormStatus === 6) {
    return {
      component: <Badge status="success" text="已归档" />,
      img: 'https://sitecdn.zcycdn.com/f2e-assets/b5ee5437-04ee-4d5b-9526-bc95f4baf2cb.svg',
      text: '已归档',
    };
  }
};

/**
 * 报销单table表头
 */
export const CLAIM_LIST_COLUMNS = APPLY_COLUMN => [
  {
    title: '单据类型',
    width: 120,
    dataIndex: 'expenseFormTypeName',
    key: 'expenseFormTypeName',
  },
  {
    title: '单据编号',
    width: 126,
    dataIndex: 'businessCode',
    key: 'businessCode',
  },
  ...APPLY_COLUMN,
  {
    title: '报销事由',
    dataIndex: 'expenseReason',
    key: 'expenseReason',
  },
  {
    title: '报销金额 (元)',
    width: 120,
    dataIndex: 'expenseAmount',
    key: 'expenseAmount',
    align: 'right',
    render: text => formatCentToYuan(text),
  },
  {
    title: '发起人',
    width: 100,
    dataIndex: 'operatorName',
    key: 'operatorName',
  },
  {
    title: '部门',
    width: 160,
    key: 'departmentName',
    render: record =>
      `${record.departmentId === -1 ? record.orgName : record.departmentName || '-'}`,
  },
  {
    title: '申请时间',
    width: 120,
    dataIndex: 'submitTime',
    key: 'submitTime',
    render: text => formatCommonDate(text),
  },
  {
    title: '状态',
    width: 90,
    key: 'expenseFormStatusDesc',
    render: record => CLAIM_STATUS_MAP(record).component,
  },
  {
    title: '当前节点',
    dataIndex: 'approvedNames',
    width: 90,
    render: record => {
      return record?.length ? (
        <Fragment>
          {record[0]}
          {record.length > 1 && <Tooltip title={record?.join('、')}>...</Tooltip>}
        </Fragment>
      ) : (
        '-'
      );
    },
  },
];

// 补贴 父类型
export const FEE_PARENT_TYPE = {
  10: 'allowanceStay', // 住宿
  20: 'allowanceTraffic', // 交通
  30: 'allowanceEat', // 伙食
  40: 'allowanceIncidental', // 公杂
  50: 'allowanceOther', // 其他,
  51: 'allowanceCollection', // 托收
  90: 'allowanceOther', // 其他
  60: 'allowanceMix', // 场地、资料、交通类
  70: 'allowanceTeachers', // 师资类
  80: 'allowanceEntertain', // 业务招待费
  88: 'totalMixCost', // 综合定额总金额
  77: 'totalTeachersCost', // 师资类总金额【模拟数据，后端无此枚举】
};

export const CHECK_STATUS_VALUE = {
  success: 0,
  warning: 1,
  error: 2,
  alert: 3,
};

export const CHECK_STATUS = {
  0: 'icon-zlb-zhengque',
  1: 'icon-zlb-weishezhi',
  2: 'icon-zlb-cuowu',
};

export const CHECK_STATUS_CLASS = {
  0: '',
  1: 'weaker',
  2: 'stronger',
  3: 'alert',
};

// 报销总金额icon
export const CHECK_AMOUNT_STATUS = {
  0: 'icon-zlb-zhengque',
  1: 'icon-zlb-a-weishezhi3x',
  2: 'icon-zlb-a-qiangkong3x',
  3: 'icon-zlb-a-qiangkong3x prompt',
};

export const CHECK_STATUS_TEXT = {
  1: 'fee-check-warning',
  2: 'fee-check-error',
  3: 'fee-check-alert',
};

export const FEE_CHECK_RULES = {
  0: 'success',
  1: 'warning',
  2: 'error',
  3: 'default',
};

export const BUDGET_COLUMNS = [
  {
    title: '预算详情ID',
    dataIndex: 'financialBudgetDetailId',
    key: 'financialBudgetDetailId',
    width: 150,
    // fixed: true,
    render: text => <TextWithTooltip placement="top" text={text} />,
  },
];
export const BUDGET_COLUMNS_OTHER = (customColumns, needSort, params) => [
  {
    title: '指标文号',
    dataIndex: 'budgetNo',
    key: 'budgetNo',
    width: 180, // 表头宽度要大于OverflowTooltip设置的maxWidth/width 33像素，表头宽度包含单元格padding和border-right宽
    render: text => <TextWithTooltip placement="top" text={text} />,
  },
  {
    title: '项目名称',
    dataIndex: 'projectName',
    key: 'projectName',
    width: 190,
    sortDirections: ['ascend', 'descend'],
    sorter: needSort === 'needSort',
    sortOrder: params?.sorter?.field === 'projectName' && params?.sorter?.order,
    render: text => <TextWithTooltip placement="top" text={text} />,
  },
  {
    title: '部门经济分类',
    dataIndex: 'depExpendEconomicClassifyName',
    key: 'depExpendEconomicClassifyName',
    width: 180,
    sortDirections: ['ascend', 'descend'],
    sorter: needSort === 'needSort',
    sortOrder: params?.sorter?.field === 'depExpendEconomicClassifyName' && params?.sorter?.order,
    render: i => (i ? i : '-'),
  },
  ...(Array.isArray(customColumns) ? customColumns : []),
  {
    title: '所属部门',
    dataIndex: 'depName',
    key: 'depName',
    width: 180,
    render: i => (i ? i : '-'),
  },
  {
    title: '支出内容',
    dataIndex: 'expenditureItem',
    key: 'expenditureItem',
    width: 180,
    render: i => (i ? i : '-'),
  },
  {
    title: '是否采购',
    dataIndex: 'containsGovPurchaseBudget',
    key: 'containsGovPurchaseBudget',
    width: 100,
    render: text => (text ? '是' : '否'),
  },
  {
    title: '资金性质',
    dataIndex: 'fundsNatureName',
    key: 'fundsNatureName',
    width: 140,
    render: i => (i ? i : '-'),
  },
  {
    title: '功能科目',
    dataIndex: 'expendFunctionClassifySubjectName',
    key: 'expendFunctionClassifySubjectName',
    width: 180,
    sortDirections: ['ascend', 'descend'],
    sorter: needSort === 'needSort',
    sortOrder:
      params?.sorter?.field === 'expendFunctionClassifySubjectName' && params?.sorter?.order,
    render: i => (i ? i : '-'),
  },
];
export const BUDGET_QUOTA_COLUMNS = budgetControl => [
  {
    title: '预算额度ID',
    dataIndex: 'quotaId',
    key: 'quotaId',
    render: text => (text ? text : '-'),
  },
  {
    title: '预算额度名称',
    dataIndex: 'quotaName',
    key: 'quotaName',
    render: text => (text ? text : '-'),
    className: 'nameOfBudgetAmount',
  },
  {
    title: '资金性质',
    dataIndex: 'fundsNatureName',
    key: 'fundsNatureName',
    width: 140,
    render: text => (text ? text : '-'),
  },
  {
    title: '部门经济分类',
    dataIndex: 'depExpendEconomicClassifyName',
    key: 'depExpendEconomicClassifyName',
    render: text => (text ? text : '-'),
  },
  {
    title: '预算额度 (元)',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    render: text => formatCentToYuan(text),
    align: 'right',
  },
  {
    title: '可用金额 (元)',
    dataIndex: 'availableAmount',
    key: 'availableAmount',
    render: text => formatCentToYuan(text),
    align: 'right',
  },
  {
    title: '本次占用金额 (元)',
    dataIndex: 'budgetAmount',
    key: 'budgetAmount',
    render: (text, record) => (
      <Form>
        <FormItem
          validateStatus={get(budgetControl, `[${record.quotaId}].validateStatus`)}
          help={get(budgetControl, `[${record?.quotaId}].help`)}
        >
          {formatCentToYuan(text)}
        </FormItem>
      </Form>
    ),
    align: 'right',
  },
];

export const BUDGET_QUOTA_MODAL_COLUMNS = [
  {
    title: '预算额度ID',
    dataIndex: 'quotaId',
    key: 'quotaId',
    render: text => (text ? text : '-'),
  },
  {
    title: '预算额度名称',
    dataIndex: 'quotaName',
    key: 'quotaName',
    render: text => (text ? text : '-'),
    className: 'nameOfBudgetAmount',
  },
  {
    title: '资金性质',
    dataIndex: 'fundsNatureName',
    key: 'fundsNatureName',
    render: text => (text ? text : '-'),
  },
  {
    title: '部门经济分类',
    dataIndex: 'depExpendEconomicClassifyName',
    key: 'depExpendEconomicClassifyName',
    render: text => {
      if (!text) return '-';
      return (
        <Tooltip title={text}>
          <span
            style={{
              textOverflow: 'ellipsis',
              display: 'block',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
            }}
          >
            {text}
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: '关联预算项目',
    dataIndex: 'projectName',
    key: 'projectName',
    render: text => {
      if (!text) return '-';
      return (
        <Tooltip title={text}>
          <span
            style={{
              textOverflow: 'ellipsis',
              display: 'block',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
            }}
          >
            {text}
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: '所属部门',
    dataIndex: 'depName',
    key: 'depName',
    render: _ => (_ ? _ : '-'),
  },
  {
    title: '预算金额 (元)',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    align: 'right',
    render: text => formatCentToYuan(text),
  },
  {
    title: '可用金额 (元)',
    dataIndex: 'availableAmount',
    key: 'availableAmount',
    align: 'right',
    render: text => formatCentToYuan(text),
  },
];

export const ADJUST_COLUMNS = [
  {
    title: '调整人',
    key: '',
    dataIndex: '',
  },
  {
    title: '调整时间',
    key: '',
    dataIndex: '',
  },
  {
    title: '调整前金额',
    key: '',
    dataIndex: '',
  },
  {
    title: '调整后金额',
    key: '',
    dataIndex: '',
  },
  {
    title: '调整原因',
    key: '',
    dataIndex: '',
  },
];
export const PAYMENT_COLUMNS = [
  {
    title: '收款人',
    dataIndex: 'receiveUserName',
    key: 'receiveUserName',
    width: 103,
    render: text =>
      text ? <OverflowTooltip style={{ maxWidth: 70 }}>{text}</OverflowTooltip> : '-',
  },
  {
    title: '收款方式',
    dataIndex: 'projectName',
    key: 'projectName',
    render: (_, record) => {
      return (
        <React.Fragment>
          <div>{record.receiveBankName}</div>
          <div>{record.receiveAccountNo}</div>
        </React.Fragment>
      );
    },
  },
  {
    title: '应付金额 (元)',
    dataIndex: 'payAmount',
    key: 'payAmount',
    align: 'right',
    render: i => {
      return formatCentToYuan(i);
    },
  },
  {
    title: '支付申请单号',
    dataIndex: 'payId',
    key: 'payId',
    render: text => text || '-',
  },
  {
    title: '支付令号',
    dataIndex: 'thirdTradeNo',
    key: 'thirdTradeNo',
    render: text => text || '-',
  },
  {
    title: '银行流水号',
    dataIndex: 'thirdPayFlowNo',
    key: 'thirdPayFlowNo',
    render: text => text || '-',
  },
  {
    title: '支付结果',
    dataIndex: 'payStatusDesc',
    key: 'payStatusDesc',
    render: payStatusDesc => {
      const getStatus = payStatusDesc => {
        switch (payStatusDesc) {
          case '支付成功': {
            return 'success';
          }
          case '支付失败': {
            return 'error';
          }
          case '支付中': {
            return 'processing';
          }
          default: {
            return 'default';
          }
        }
      };

      return (
        <React.Fragment>
          <Badge status={getStatus(payStatusDesc)} />
          <span>{payStatusDesc}</span>
        </React.Fragment>
      );
    },
  },
];

export const PAYMENT_COLUMNS_FAIL = [
  {
    title: '结果描述',
    dataIndex: 'failureReason',
    key: 'failureReason',
    render: i => (i ? <OverflowTooltip style={{ maxWidth: 180 }}>{i}</OverflowTooltip> : '-'),
  },
];

export const AUDIT_STATUS_MAP = {
  1: 'https://sitecdn.zcycdn.com/f2e-assets/f1efdd5c-e30d-4a46-92c7-94be2e5c57a2.svg',
  2: 'https://sitecdn.zcycdn.com/f2e-assets/4a9f24bd-d03b-4510-8b86-275d9a18fcf1.svg',
};

// 预算列表请求参数reimburseType
export const BUDGET_CODE = {
  [EXPENSE_FORM_TYPE_MAP.trip]: 11010,
  [EXPENSE_FORM_TYPE_MAP.meeting]: 11011,
  [EXPENSE_FORM_TYPE_MAP.training]: 11012,
  [EXPENSE_FORM_TYPE_MAP.purchase]: 11013,
  [EXPENSE_FORM_TYPE_MAP.reception]: 11014,
  [EXPENSE_FORM_TYPE_MAP.general]: 11015,
  [EXPENSE_FORM_TYPE_MAP.common]: 11017,
  [EXPENSE_FORM_TYPE_MAP.services]: 11019,
  [EXPENSE_FORM_TYPE_MAP.furniture]: 11018,
  [EXPENSE_FORM_TYPE_MAP.multipleMeeting]: 11011,
  [EXPENSE_FORM_TYPE_MAP.multipleTraining]: 11012,
  [EXPENSE_FORM_TYPE_MAP.batchDistribute]: 11020,
  [EXPENSE_FORM_TYPE_MAP.publicPayment]: 11021,
  [EXPENSE_FORM_TYPE_MAP.salary]: 11016, // 工资
  [EXPENSE_FORM_TYPE_MAP.overtime]: 11022, // 夜餐费 后面可能有自己的
  [EXPENSE_FORM_TYPE_MAP.batchDistribute_cash]: 11024,
  [EXPENSE_FORM_TYPE_MAP.governmentInvestmentPayment]: 11025, // 政府投资支付单
  [EXPENSE_FORM_TYPE_MAP.automaticDeduction]: 11027, //  单位托收
  // [EXPENSE_FORM_TYPE_MAP.unitRepayment]: 11028, // 代扣还款（单位）申请
  [EXPENSE_FORM_TYPE_MAP.carUseService]: 11028,
};
// 前后加签
export const ADD_TYPE = {
  before: 1,
  after: 2,
};

/**
 * 差旅费用列表默认值
 */
export const DEFAULT_EXPENSE_FEE = {
  allowanceEat: {
    indexNo: uuidv4(),
    feeParentType: 30,
    expenseFeePOS: [],
    feeParentTypeDesc: '伙食补贴',
    totalAmount: 0,
  },
  allowanceIncidental: {
    indexNo: uuidv4(),
    feeParentType: 40,
    expenseFeePOS: [],
    feeParentTypeDesc: '公杂补贴',
    totalAmount: 0,
  },
  allowanceStay: {
    indexNo: uuidv4(),
    feeParentType: 10,
    expenseFeePOS: [],
    feeParentTypeDesc: '住宿类',
    totalAmount: 0,
  },
  allowanceTraffic: {
    indexNo: uuidv4(),
    feeParentType: 20,
    expenseFeePOS: [],
    feeParentTypeDesc: '交通类',
    totalAmount: 0,
  },
  allowanceEntertain: {
    indexNo: uuidv4(),
    feeParentType: 80,
    expenseFeePOS: [],
    feeParentTypeDesc: '业务招待费',
    totalAmount: 0,
  },
  allowanceOther: {
    indexNo: uuidv4(),
    feeParentType: 50,
    expenseFeePOS: [],
    feeParentTypeDesc: '其他类',
    totalAmount: 0,
  },
};

export const payMethodMap = {
  1: '一次性付款',
  2: '分期付款',
};

export const EXPENSE_TITLE_MAP = {
  9: '通用采购报销单',
  10: '政府购买服务报销单',
  11: '办公设备家具购置报销单',
  21: '公车服务报销单',
};

// 报销单 businessType 枚举
export const EXPENSE_TYPE_MAP = {
  9: 'common',
  10: 'services',
  11: 'furniture',
  21: 'carUseService',
};

export const AUTOGRAPH_ICON =
  'https://sitecdn.zcycdn.com/f2e-assets/8fb6bf5e-6327-4f4c-9e62-08df2c8a5663.svg';

// NEED_SIGN(10001, "该票据需要签名"),
// ALREADY_EXPENSE(10002, "该票据已被其他报销单使用"),
// COMPLETE(10003, "该票据已完结"),
// NOT_EXISTS(10004, "该票据不存在"),
// HAS_BEEN_COLLECT(10005,"该票据已被他人保存"),
// REPEAT_INVOICE(10007,"重复票据") // 跨省票新增code
export const STRONG_CONTROL_CODE = {
  NEED_SIGN: 10001,
  ALREADY_EXPENSE: 10002,
  COMPLETE: 10003,
  NOT_EXISTS: 10004,
  HAS_BEEN_COLLECT: 10005,
  REPEAT_INVOICE: 10007,
};

// 1-公务卡；2-普通银行卡；3-单位工资卡；4-对公供应商银行卡；5-对私供销商银行卡 6-单位账户
export const CARD_TYPE_MAP = {
  1: '公务卡',
  2: '个人卡',
  7: '外部人员卡',
  // 3: '单位工资卡', // 历史代码未开放这些类型，后续有要求再处理
  // 4: '对公供应商', // 对公供应商
  // 5: '对私供应商', // 对私供应商
  // 6: '单位账户',
};

export const CLAIM_PAYEE_TYPE = {
  single: 1,
  multiple: 2,
};

export const TRADE_STEP_ENUM = {
  ORDER_STEP: [
    {
      title: '选择订单',
      current: 0,
    },
    {
      title: '确认交易信息',
      current: 1,
    },
    {
      title: '设置费用归属',
      current: 2,
    },
    {
      title: '确认收款人',
      current: 3,
    },
  ],
  CONTRACT: [
    {
      title: '添加合同',
      current: 0,
    },
    {
      title: '确认交易信息',
      current: 1,
    },
    {
      title: '设置费用归属',
      current: 2,
    },
    {
      title: '确认收款人',
      current: 3,
    },
  ],
  FEE: [
    {
      title: '确认收款人',
      current: 0,
    },
    {
      title: '设置费用归属',
      current: 1,
    },
    {
      title: '补充票据信息',
      current: 2,
    },
    {
      title: '确认交易信息',
      current: 3,
    },
  ],
  ONLINE_CONTRACT: [
    {
      title: '添加合同',
      current: 0,
    },
    {
      title: '确认交易信息',
      current: 1,
    },
  ],
  PURCHASE: [
    {
      title: '选择订单',
      current: 0,
    },
    {
      title: '确认交易信息',
      current: 1,
    },
  ],
};
// TRADETableStatus
export const TRADE_TABLE_STATUS = {
  // eslint-disable-next-line no-unused-vars
  edit: 1,
  // eslint-disable-next-line no-unused-vars
  detail: 2,
  // eslint-disable-next-line no-unused-vars
  audit: 3,
};

export const TRADE_TYPE = {
  contract: 'contract',
  order: 'order',
  fee: 'fee',
  zcyContract: 'zcyContract',
};

export const TRADE_BUSINESS_TYPE = {
  order: 1, // 政采云订单
  zcyContract: 2, // 政采云合同
  contract: 3, // 线下合同
  fee: 4, // 直接添加费用
  onlineStore: 5, // 电子卖场
  onlineCommissionedProcurement: 6, // 线上-采购委托采购
  onlinePurchaseSelf: 7, // 线上-采购
  onlineOther: 8, // 线上其他
  offlineContract: 9, // 线下-其他-有合同
  offlineNoContract: 10, // 线下-其他-无合同
  purchaseOrder: 11, // 政采云订单（办公采购专属）
  payInfo: 12, // 支付信息 义乌付款信息
  zlbContract: 13, // 浙里报合同中心
};

/**
 * 数据类型
 * @param {*} businessType
 * @returns
 */
export const getTradeDataType = businessType => {
  if (
    [
      TRADE_BUSINESS_TYPE.order,
      TRADE_BUSINESS_TYPE.onlineStore,
      TRADE_BUSINESS_TYPE.purchaseOrder,
    ].includes(businessType)
  ) {
    return 'order';
  } else if (
    [
      TRADE_BUSINESS_TYPE.zcyContract,
      TRADE_BUSINESS_TYPE.onlineCommissionedProcurement,
      TRADE_BUSINESS_TYPE.onlinePurchaseSelf,
      TRADE_BUSINESS_TYPE.onlineOther,
    ].includes(businessType)
  ) {
    return 'contract';
  } else if (businessType === TRADE_BUSINESS_TYPE.payInfo) {
    return 'payInfo';
  } else {
    return 'other';
  }
};
export const CONTRACT_DATAS_SOURCE = {
  zcy: 2, // 政采云
  create: 3, // 手动添加
};

export const TRADE_BUSINESS_TYPE_DESC = {
  order: '选择政采云订单',
  zcyContract: '导入合同',
  contract: '添加线下合同',
  fee: '直接添加费用',
  onlineStore: '线上-电子卖场',
  onlineCommissionedProcurement: '线上-项目采购委托采购',
  onlinePurchaseSelf: '线上-项目采购自行采购',
  onlineOther: '线上-其他',
  offlineContract: '线下-其他-有合同',
  offlineNoContract: '线下-其他-无合同',
  purchaseOrder: '政采云订单',
  payInfo: '合同付款申请单',
};
// 会议默认费用
export const MEETING_EXPENSE_FEE_POS = {
  allowanceStay: {
    indexNo: uuidv4(),
    feeParentType: 10,
    expenseFeePOS: [],
    feeParentTypeDesc: '住宿类',
    totalAmount: 0,
  },
  allowanceEat: {
    indexNo: uuidv4(),
    feeParentType: 30,
    expenseFeePOS: [],
    feeParentTypeDesc: '伙食类',
    totalAmount: 0,
  },
  allowanceOther: {
    indexNo: uuidv4(),
    feeParentType: 50,
    expenseFeePOS: [],
    feeParentTypeDesc: '其他类',
    totalAmount: 0,
  },
};
// 培训默认费用
export const TRAINING_EXPENSE_FEE_POS = {
  allowanceStay: {
    indexNo: uuidv4(),
    feeParentType: 10,
    expenseFeePOS: [],
    feeParentTypeDesc: '住宿类',
    totalAmount: 0,
  },
  allowanceEat: {
    indexNo: uuidv4(),
    feeParentType: 30,
    expenseFeePOS: [],
    feeParentTypeDesc: '伙食类',
    totalAmount: 0,
  },
  allowanceMix: {
    indexNo: uuidv4(),
    feeParentType: 60,
    expenseFeePOS: [],
    feeParentTypeDesc: '场地、资料、交通类',
    totalAmount: 0,
  },
  allowanceOther: {
    indexNo: uuidv4(),
    feeParentType: 50,
    expenseFeePOS: [],
    feeParentTypeDesc: '其他类',
    totalAmount: 0,
  },
  totalMixCost: {
    totalAmount: 0,
    type: 'feeTotal',
    typeCode: 'mix',
    feeParentType: 88,
    feeParentTypeDesc: '综合定额合计：',
  },
  allowanceTeachers: {
    indexNo: uuidv4(),
    feeParentType: 70,
    expenseFeePOS: [],
    feeParentTypeDesc: '师资类',
    totalAmount: 0,
  },
  totalTeachersCost: {
    totalAmount: 0,
    type: 'feeTotal',
    typeCode: 'teachers',
    feeParentType: 77,
    feeParentTypeDesc: '师资金额合计：',
  },
};
export const SIGN_TYPE = {
  table: 1,
  file: 2,
};
export const PAY_STATUS = {
  ready: 0,
  pendding: 1,
  success: 2,
  failed: 3,
};

export const getPayChangeColumns = options => {
  const { showBudgetDetail, showPaymentLimitDetail } = options;
  const ellipsisStyle = {
    display: 'inline-block',
    maxWidth: '300px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
  };
  return [
    {
      title: '更正前',
      key: 'pre',
      render: record => {
        return (
          <div>
            <div>
              <span className="label">预算指标ID:&nbsp;</span>
              <span className="value">
                {get(record, 'oldBudgetInfoRO.financialBudgetDetailId', '-')} &nbsp;
                <a
                  className="btn"
                  onClick={() => {
                    showBudgetDetail(get(record, 'oldBudgetInfoRO.mainBudgetCode'));
                  }}
                >
                  查看
                </a>
              </span>
            </div>
            <div>
              <span className="label">指标文号:&nbsp;</span>
              <span className="value">{get(record, 'oldBudgetInfoRO.budgetNo', '-')}</span>
            </div>
            <div>
              <span className="label">支付限额:&nbsp;</span>
              <span className="value">
                <Tooltip title={get(record, 'oldBpcInfo.name', '-')}>
                  <span style={ellipsisStyle}>{get(record, 'oldBpcInfo.name', '-')} &nbsp;</span>
                </Tooltip>
                {get(record, 'oldBpcInfo.uk') && (
                  <a
                    className="btn"
                    onClick={() => {
                      showPaymentLimitDetail(get(record, 'oldBpcInfo.uk'));
                    }}
                  >
                    查看
                  </a>
                )}
              </span>
            </div>
            <div>
              <span className="label">支付令号:&nbsp;</span>
              <span className="value">{get(record, 'oldThirdTradeNo', '-')}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: '更正后',
      key: 'aft',
      render: record => {
        return (
          <div>
            <div>
              <span className="label">预算指标ID:&nbsp;</span>
              <span className="value">
                {get(record, 'newBudgetInfoRO.financialBudgetDetailId', '-')}
              </span>
              &nbsp;
              <a
                className="btn"
                onClick={() => {
                  showBudgetDetail(get(record, 'newBudgetInfoRO.mainBudgetCode'));
                }}
              >
                查看
              </a>
            </div>
            <div>
              <span className="label">指标文号:&nbsp;</span>
              <span className="value">{get(record, 'newBudgetInfoRO.budgetNo', '-')}</span>
            </div>
            <div>
              <span className="label">支付限额:&nbsp;</span>
              <span className="value">
                <Tooltip title={get(record, 'newBpcInfo.name', '-')}>
                  <span style={ellipsisStyle}>{get(record, 'newBpcInfo.name', '-')} &nbsp;</span>
                </Tooltip>
                {get(record, 'newBpcInfo.uk') && (
                  <a
                    className="btn"
                    onClick={() => {
                      showPaymentLimitDetail(get(record, 'newBpcInfo.uk'));
                    }}
                  >
                    查看
                  </a>
                )}
              </span>
            </div>
            <div>
              <span className="label">支付令号:&nbsp;</span>
              <span className="value">{get(record, 'newThirdTradeNo', '-')}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: '支付金额 (元)',
      key: 'amount',
      align: 'right',
      dataIndex: 'amount',
      render: text => {
        return <div>{formatCentToYuan(text || 0)}</div>;
      },
    },
  ];
};

export const WITHOUT_INVOICE_STATUS = {
  normal: 0, // 正常报销
  withoutInvoice: 1, // 无票报销， 待补充
  replenished: 2, // 无票报销， 已补充
};

// 上城是否属于车辆维修或加油的费用-费用类型
export const MAINTENANCE_FEE_TYPE = {
  1: '车辆维修',
  2: '加油费用',
  3: '车辆保险',
  4: '车辆租赁',
  99: '其他',
};

// 上城是否属于车辆维修或加油的费用-车辆性质
export const VEHICLE_NATURE_FEE_TYPE = {
  1: '应急保障用车',
  2: '老干部服务用车',
  3: '执法执勤用车',
  4: '省部级领导用车',
  5: '特种专业技术用车',
  6: '执政执法专用车',
  7: '机要通信用车',
  8: '业务用车',
  9: '应急调研用车',
};

// 合同导入方式
export const CONTRACT_IMPORT_TYPE = {
  order: 1,
  contract: 2,
};

/**
 * 兑付申报单详情状态
 */
export const REDEMPT_DECLARAT_STATUS_MAP = ({ fundApplyDisburseFlag, payStatus }) => {
  if (fundApplyDisburseFlag) {
    return {
      img: 'https://sitecdn.zcycdn.com/f2e-assets/e59b31b5-4014-4df3-8cb5-816d237c6bdc.svg',
      text: '资金申拨',
    };
  } else {
    if (payStatus === 0) {
      return {
        img: 'https://sitecdn.zcycdn.com/f2e-assets/ab015eef-fe2d-438a-a93e-25079339a9b2.svg',
        text: '待兑付',
      };
    }
    if (payStatus === 1) {
      return {
        img: 'https://sitecdn.zcycdn.com/f2e-assets/7e3c1649-c07f-49ce-9262-3cde5d5c3d6e.svg',
        text: '已兑付',
      };
    }
    if (payStatus === 2) {
      return {
        img: 'https://sitecdn.zcycdn.com/f2e-assets/be0439b7-7bd5-4c1e-82d3-fd5c5892d02f.svg',
        text: '兑付失败',
      };
    }
  }
};
